import { render, staticRenderFns } from "./DefRegisterListForDetail.vue?vue&type=template&id=0c1c9aca&scoped=true&"
import script from "./DefRegisterListForDetail.vue?vue&type=script&lang=js&"
export * from "./DefRegisterListForDetail.vue?vue&type=script&lang=js&"
import style0 from "./DefRegisterListForDetail.vue?vue&type=style&index=0&id=0c1c9aca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1c9aca",
  null
  
)

export default component.exports